import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  changeDateFormat,
  checkArray,
  checkNull,
  createSelectOptions,
  decimalValue,
  parseStringToDate,
} from "../../../../../helpers";
import {
  addFinanceSubAccountDetails,
  changeSettingValue,
  getSubAccountTransactionsDetails,
  getUpdateFinanceSubAccountDetails,
  saveEditSubAccountDetails,
  saveFinanceSubAccountDetails,
} from "../../../../../Redux/actions";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";

const EditSubAccount = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    add_accounts_details,
    is_redirect_accounts_id,
    sub_acc_transactions_details,
  } = useSelector((state) => state.settingReducer);
  const financeAcc = add_accounts_details?.data;
  let { id } = useParams();
  const pagesize = 10;

  useEffect(() => {
    dispatch(getUpdateFinanceSubAccountDetails(`/${id}`));
    dispatch(changeSettingValue("is_redirect_accounts_id", false));
    getTransactionsHandler(1);
    return () => {
      dispatch(changeSettingValue("add_accounts_details", null));
      dispatch(changeSettingValue("is_redirect_accounts_id", false));
    };
  }, []);

  const getTransactionsHandler = (page = 1) => {
    dispatch(getSubAccountTransactionsDetails(`/${id}`, { page, pagesize }));
  };

  useEffect(() => {
    if (is_redirect_accounts_id) history.goBack();
  }, [is_redirect_accounts_id]);

  const [addAccForm, setaddAccForm] = useState({
    id: "",
    name: "",
    payee_id: "",
    default_payment_account_id: "",
    unrealized_pl: "",
    company_id: "",
    purchase_value: "",
    taxable: "",
    bank_name: "",
    bank_account_no: "",
    common_stock: "",
    paid_in_capital: "",
  });

  useEffect(() => {
    const newCommonStock =
      parseFloat(financeAcc?.parent?.par_value) *
      parseFloat(financeAcc?.purchase_value);
    const newPaidCapital =
      parseFloat(financeAcc?.current_balance) - parseFloat(newCommonStock) >= 0
        ? parseFloat(financeAcc?.current_balance) - parseFloat(newCommonStock)
        : 0;

    const newAccForm = {
      id: checkNull(financeAcc?.id),
      name: checkNull(financeAcc?.name),
      payee_id: checkNull(financeAcc?.payee_id),
      default_payment_account_id: checkNull(
        financeAcc?.default_payment_account_id
      ),
      unrealized_pl: checkNull(financeAcc?.useful_life),
      company_id: checkNull(financeAcc?.company_id),
      purchase_value: checkNull(financeAcc?.purchase_value),
      taxable: checkNull(financeAcc?.taxable),
      bank_name: checkNull(financeAcc?.bank_name),
      bank_account_no: checkNull(financeAcc?.bank_account_no),
      finance_group_id: checkNull(financeAcc?.finance_group_id),
      common_stock: newCommonStock,
      paid_in_capital: newPaidCapital,
    };
    setaddAccForm(newAccForm);
  }, [financeAcc]);

  const accFormChangeHandler = (input, val) => {
    setaddAccForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const submitAccFormHandler = (isSave = true) => {
    dispatch(saveEditSubAccountDetails(`/${id}`, addAccForm, isSave));
  };

  const bankAccCon = () => {
    if (addAccForm?.is_bank_account == 1) {
      return (
        <div class="col-md-6 right-section bankDiv">
          <ul class="ingredient-info edit-shift">
            <li>
              <label class="required">Custodian/Bank Name</label>
              <div class="input-group col-md-7">
                <input
                  type="text"
                  name={"bank_name"}
                  className="required"
                  value={addAccForm?.bank_name}
                />
              </div>
            </li>
            <li>
              <label class="required">Account Number</label>
              <div class="input-group col-md-7">
                <input
                  type="text"
                  name={"bank_account_no"}
                  className="required"
                  value={addAccForm?.bank_account_no}
                />
              </div>
            </li>
            <li>
              <label class="required">Opening Balance</label>
              <div class="input-group col-md-7">
                {decimalValue(
                  financeAcc?.opening_balance2,
                  2,
                  add_accounts_details?.currency
                )}
              </div>
            </li>
          </ul>
        </div>
      );
    }
  };

  const footerCon = () => {
    return (
      <>
        <div class="btns col-4 d-flex justify-content-end py-4 col-12">
          <input
            type="button"
            value="Apply"
            id="applyBut"
            onClick={() => submitAccFormHandler(false)}
          />
          <input
            type="button"
            value="Submit"
            id="submitBut"
            onClick={() => submitAccFormHandler()}
          />
          <input
            type="button"
            value="Cancel"
            id="cancelBut"
            onClick={() => history.goBack()}
          />
        </div>
      </>
    );
  };

  const commonStock =
    parseFloat(financeAcc?.parent?.par_value) *
    parseFloat(financeAcc?.purchase_value);
  const paidCapital =
    parseFloat(financeAcc?.current_balance) - parseFloat(commonStock) >= 0
      ? parseFloat(financeAcc?.current_balance) - parseFloat(commonStock)
      : 0;

  const yesNoObj = { 0: "No", 1: "Yes" };

  const getFormAccAccount = () => {
    let res = null;
    const accPrefix = financeAcc?.prefix ?? "";
    if (accPrefix == "L01") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label class="required">Outstanding Amount?</label>
                <div class="input-group col-md-7">
                  {addAccForm?.current_balance}
                </div>
              </li>
              <li>
                <label class="required">Select Payee</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="payee_id"
                    id="payee_id"
                    onChange={(e) =>
                      accFormChangeHandler("payee_id", e?.target?.value)
                    }
                    value={addAccForm?.payee_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.payees)}
                  </select>
                </div>
              </li>
              <li>
                <label class="required">Default Payment Acct.</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="default_payment_account_id"
                    id="default_payment_account_id"
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_payment_account_id",
                        e?.target?.value
                      )
                    }
                    value={addAccForm?.default_payment_account_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(
                      add_accounts_details?.default_payment_accounts
                    )}
                  </select>
                </div>
              </li>
            </ul>
          </div>
          {bankAccCon()}

          {footerCon()}
        </div>
      );
    } else if (accPrefix == "L02" || accPrefix == "L03" || accPrefix == "L06") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Liabilities Group</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.finance_group?.name ?? ""}</p>
                </div>
              </li>
              <li>
                <label class="required">Asset Account</label>
                <div class="input-group col-md-7">
                  <p>
                    <input
                      type="text"
                      name={"name"}
                      className="required"
                      value={addAccForm?.name}
                      onChange={(e) =>
                        accFormChangeHandler("name", e?.target?.value)
                      }
                    />
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Default Payment Acct.</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="default_payment_account_id"
                    id="default_payment_account_id"
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_payment_account_id",
                        e?.target?.value
                      )
                    }
                    value={addAccForm?.default_payment_account_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(
                      add_accounts_details?.default_payment_accounts
                    )}
                  </select>
                </div>
              </li>
            </ul>
          </div>
          {bankAccCon()}
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "L04" || accPrefix == "L05") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Account</label>
                <div class="input-group col-md-7">
                  <p>
                    <input
                      type="text"
                      name={"name"}
                      className="required"
                      value={addAccForm?.name}
                      onChange={(e) =>
                        accFormChangeHandler("name", e?.target?.value)
                      }
                    />
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Payee Name</label>
                <div class="input-group col-md-7">
                  <select
                    name="payee_id"
                    id="payee_id"
                    onChange={(e) =>
                      accFormChangeHandler("payee_id", e?.target?.value)
                    }
                    value={addAccForm?.payee_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.payees)}
                  </select>
                </div>
              </li>
              <li>
                <label class="required">Initial Principle Amount</label>
                <div class="input-group col-md-7">
                  <p>
                    {" "}
                    {decimalValue(
                      addAccForm?.initial_principle_amount,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Outstanding Amount</label>
                <div class="input-group col-md-7">
                  <p>
                    {decimalValue(
                      addAccForm?.outstanding_amount,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Default Payment Acct.</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name="default_payment_account_id"
                    id="default_payment_account_id"
                    onChange={(e) =>
                      accFormChangeHandler(
                        "default_payment_account_id",
                        e?.target?.value
                      )
                    }
                    value={addAccForm?.default_payment_account_id}
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(
                      add_accounts_details?.default_payment_accounts
                    )}
                  </select>
                </div>
              </li>
            </ul>
          </div>
          {bankAccCon()}
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "A01" || accPrefix == "A08") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Account</label>
                <div class="input-group col-md-7">
                  <p>
                    <input
                      type="text"
                      name={"name"}
                      className="required"
                      value={addAccForm?.name}
                      onChange={(e) =>
                        accFormChangeHandler("name", e?.target?.value)
                      }
                    />
                  </p>
                </div>
              </li>
              {addAccForm?.is_bank_account == 1 && (
                <li class="nonBankDiv">
                  <label class="required">Opening Balance</label>
                  <div class="input-group col-md-7">
                    {decimalValue(
                      financeAcc?.purchase_value,
                      2,
                      add_accounts_details?.currency
                    )}
                  </div>
                </li>
              )}
            </ul>
          </div>
          {bankAccCon()}
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "A04" || accPrefix == "A07" || accPrefix == "A17") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Investment ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Investment Name</label>
                <div class="input-group col-md-7">
                  <p>
                    <input
                      type="text"
                      name={"name"}
                      className="required"
                      value={addAccForm?.name}
                      onChange={(e) =>
                        accFormChangeHandler("name", e?.target?.value)
                      }
                    />
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Purchase Value</label>
                <div class="input-group col-md-7">
                  <p>
                    {decimalValue(
                      addAccForm?.purchase_value,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Current Value</label>
                <div class="input-group col-md-7">
                  <p>
                    {decimalValue(
                      addAccForm?.current_value,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
              <li>
                <label>Realised P&L</label>
                <div class="input-group col-md-7">
                  <p>
                    {decimalValue(
                      addAccForm?.realized_pl,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
              <li>
                <label class="required">Unrealized P&L</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"unrealized_pl"}
                    className="currency"
                    value={addAccForm?.unrealized_pl}
                    onChange={(e) =>
                      accFormChangeHandler("unrealized_pl", e?.target?.value)
                    }
                  />
                </div>
              </li>
            </ul>
          </div>
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "A05") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Asset ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Asset Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label class="required">Purchase Value</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.purchase_value,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="required">Current Value</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.current_value,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="required">Accum. Depreciation</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.depreciation,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="required">Salvage Value</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.salvage_value,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="required">Useful Life</label>
                <div class="input-group col-md-7">
                  {addAccForm?.useful_life} Years
                </div>
              </li>
            </ul>
          </div>

          {bankAccCon()}
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "A06") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Asset ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Deposit Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label class="required">Deposit Value</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.current_balance,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
            </ul>
          </div>
          {bankAccCon()}
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "A02" || accPrefix == "A11" || accPrefix == "A13") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label class="required">Current Balance</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.current_balance,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>

              <li>
                <label class="required">Company ID</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"company_id"}
                    className="required"
                    value={addAccForm?.company_id}
                    onChange={(e) =>
                      accFormChangeHandler("company_id", e?.target?.value)
                    }
                  />
                </div>
              </li>
            </ul>
          </div>

          {bankAccCon()}
          {footerCon()}
        </div>
      );
    } else if (accPrefix == "E01") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Issuance ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Issuance Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label>Issuance Amount</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.current_balance,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label class="required">Shares Issued</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"purchase_value"}
                    className="required number_format currency"
                    value={addAccForm?.purchase_value}
                    onChange={(e) =>
                      accFormChangeHandler("purchase_value", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label>Par Value Per Share</label>
                <div class="input-group col-md-7">
                  {decimalValue(
                    addAccForm?.par_value,
                    2,
                    add_accounts_details?.currency
                  )}
                </div>
              </li>
              <li>
                <label>Common Stock</label>
                <div class="input-group col-md-7">
                  <p id="commonStock">
                    {decimalValue(
                      commonStock,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                  {/* <?php echo $this->Form->hidden('common_stock', array('id'=>'CommonStock')); ?> */}
                </div>
              </li>
              <li>
                <label>Paid-In Capital</label>
                <div class="input-group col-md-7">
                  <p id="paidCapital">
                    {decimalValue(
                      paidCapital,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                  {/* <?php echo $this->Form->hidden('paid_in_capital', array('id'=>'PaidInCapital')); ?> */}
                </div>
              </li>
            </ul>
          </div>

          {footerCon()}
        </div>
      );
    } else if (accPrefix == "E02") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Net Income ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                </div>
              </li>
              <li>
                <label class="required">Account Period</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.year}</p>
                </div>
              </li>
              <li>
                <label>Net Income Earned</label>
                <div class="input-group col-md-7">
                  <p>
                    {decimalValue(
                      addAccForm?.net_income,
                      2,
                      add_accounts_details?.currency
                    )}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      );
    } else if (
      financeAcc?.finance_type_id == "X08" ||
      financeAcc?.finance_type_id == "X1102" ||
      financeAcc?.finance_type_id == "X1103" ||
      financeAcc?.finance_type_id == "X2100" ||
      financeAcc?.finance_type_id == "X2101"
    ) {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              {addAccForm?.is_bank_account == 1 && (
                <li class="nonBankDiv">
                  <label class="required">Opening Balance</label>
                  <div class="input-group col-md-7">
                    {decimalValue(
                      financeAcc?.opening_balance,
                      2,
                      add_accounts_details?.currency
                    )}
                  </div>
                </li>
              )}
            </ul>
          </div>
          {bankAccCon()}
          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
        </div>
      );
    } else if (financeAcc?.finance_type_id == "1") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID </label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  {financeAcc?.editable == 1 ? (
                    <input
                      type="text"
                      name={"name"}
                      className="required"
                      value={addAccForm?.name}
                      onChange={(e) =>
                        accFormChangeHandler("name", e?.target?.value)
                      }
                    />
                  ) : (
                    `${financeAcc?.name}`
                  )}
                </div>
              </li>
              <li>
                <label class="required">Taxable?</label>
                <div class="input-group col-md-7">
                  {financeAcc?.editable == 1 ? (
                    yesNoObj?.[financeAcc?.taxable]
                  ) : (
                    <select
                      name="taxable"
                      id="taxable"
                      value={addAccForm?.taxable}
                      className="required"
                      onChange={(e) =>
                        accFormChangeHandler("taxable", e?.target?.value)
                      }
                    >
                      <option value="">Select</option>
                      {createSelectOptions(yesNoObj)}
                    </select>
                  )}
                </div>
              </li>

              <li>
                <label class="required">Income Group</label>
                <div class="input-group col-md-7">
                  {financeAcc?.editable == 0 ? (
                    financeAcc?.finance_group?.name
                  ) : (
                    <select
                      name="finance_group_id"
                      id="finance_group_id"
                      value={addAccForm?.finance_group_id}
                      className="required"
                      onChange={(e) =>
                        accFormChangeHandler(
                          "finance_group_id",
                          e?.target?.value
                        )
                      }
                    >
                      <option value="">Select</option>
                      {createSelectOptions(add_accounts_details?.incGroups)}
                    </select>
                  )}
                </div>
              </li>
            </ul>
          </div>
          {financeAcc?.editable == 1 && footerCon()}
        </div>
      );
    } else if (financeAcc?.finance_type_id == "2") {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  {financeAcc?.editable == 1 ? (
                    <input
                      type="text"
                      name={"name"}
                      className="required"
                      value={addAccForm?.name}
                      onChange={(e) =>
                        accFormChangeHandler("name", e?.target?.value)
                      }
                    />
                  ) : (
                    `${financeAcc?.name}`
                  )}
                </div>
              </li>
              <li>
                <label>Parent Account</label>
                <div class="input-group col-md-7">
                  {financeAcc?.parent?.name}
                </div>
              </li>
            </ul>
          </div>

          <div class="clear"> &nbsp; </div>
          {financeAcc?.editable == 1 && footerCon()}
        </div>
      );
    } else {
      res = (
        <div class="row-fluid shifts">
          <div class="col-md-6">
            <ul class="ingredient-info edit-shift">
              <li>
                <label>Account ID</label>
                <div class="input-group col-md-7">
                  <p>{financeAcc?.account_id}</p>
                  {/* <input type="text" name={"id"} value={id} /> */}
                </div>
              </li>
              <li>
                <label class="required">Sub-Account Name</label>
                <div class="input-group col-md-7">
                  <input
                    type="text"
                    name={"name"}
                    className="required"
                    value={addAccForm?.name}
                    onChange={(e) =>
                      accFormChangeHandler("name", e?.target?.value)
                    }
                  />
                </div>
              </li>
              <li>
                <label class="required">Bank Account?</label>
                <div class="input-group col-md-7">
                  {addAccForm?.is_bank_account == 1 ? "Yes" : "No"}
                </div>
              </li>
              {addAccForm?.is_bank_account == 1 && (
                <li class="nonBankDiv">
                  <label class="required">Opening Balance</label>
                  <div class="input-group col-md-7">
                    {decimalValue(
                      financeAcc?.opening_balance,
                      2,
                      add_accounts_details?.currency
                    )}
                  </div>
                </li>
              )}
            </ul>
          </div>
          {bankAccCon()}
          <div class="clear"> &nbsp; </div>
          <div class="clear"> &nbsp; </div>
          {financeAcc?.editable == 1 && footerCon()}
        </div>
      );
    }
    return res;
  };

  const getPaginationContainer = () => {
    let res = null;
    if (
      checkNull(sub_acc_transactions_details?.last_page, false) &&
      sub_acc_transactions_details?.last_page > 1
    ) {
      const pagesArr = Array.from(
        { length: sub_acc_transactions_details?.last_page },
        (_, i) => i + 1
      );
      res = (
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            {pagesArr.map((pageNo) => {
              return (
                <li
                  class={`page-item${
                    pageNo == sub_acc_transactions_details?.current_page
                      ? " active"
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      !(pageNo == sub_acc_transactions_details?.current_page)
                    ) {
                      getTransactionsHandler(pageNo);
                    }
                  }}
                >
                  <a class="page-link">{pageNo}</a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    }
    return res;
  };

  const getTransactionsContainer = () => {
    return (
      <div class="row-fluid">
        <div class="shadowclass m-0">
          <div class="row-fluid">
            <div class="span4">
              <div class="search-box">
                <input
                  type="text"
                  id="HistorySearchTag"
                  placeholder="Search"
                  name="keyword1"
                />
                <input type="button" />
              </div>
            </div>
          </div>
          <div class="inner-space screen-scroll">
            <div className="table-responsive">
              <table
                width="100%"
                cellspacing="0"
                cellpadding="0"
                class="checklist-table tableSec"
                filterBy="#HistorySearchTag"
              >
                <thead>
                  <tr>
                    <th>Transaction ID</th>
                    <th>Trans. Date</th>
                    <th>Value Date</th>
                    <th>Trans. Desc.</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Running Balance</th>
                    <th>Opposing Acct. Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {checkArray(sub_acc_transactions_details?.data) &&
                    sub_acc_transactions_details?.data.map((transaction) => {
                      const oppType =
                        transaction?.debit_account_id == id
                          ? "Credit"
                          : "Debit";
                      return (
                        <tr class="main-row link-tr">
                          <td>{transaction?.transaction_id}</td>
                          <td>
                            {changeDateFormat(
                              transaction?.transaction_date,
                              "MMMM DD, yyyy"
                            )}
                          </td>
                          <td>
                            {changeDateFormat(
                              transaction?.value_date,
                              "MMMM DD, yyyy"
                            )}
                          </td>
                          <td>{transaction?.description}</td>
                          <td>
                            {transaction?.debit_or_credit == "debit" &&
                              decimalValue(
                                transaction?.transaction_amount,
                                2,
                                add_accounts_details?.currency
                              )}
                          </td>
                          <td>
                            {transaction?.debit_or_credit == "credit" &&
                              decimalValue(
                                transaction?.transaction_amount,
                                2,
                                add_accounts_details?.currency
                              )}
                          </td>
                          <td>
                            {decimalValue(
                              transaction?.current_balance,
                              2,
                              add_accounts_details?.currency
                            )}
                          </td>

                          <td>
                            {transaction?.credit_account_id != 0 &&
                            checkNull(
                              transaction?.[`${oppType}Account2`],
                              false
                            ) &&
                            transaction?.[`${oppType}Account2`] !=
                              "PaymentMethod"
                              ? transaction?.[`${oppType}Account2`]?.name ?? ""
                              : transaction?.[
                                  `${transaction?.[oppType + "Account2"]}`
                                ]?.method_name ?? ""}
                          </td>
                          <td className="action-td">
                            {financeAcc?.finance_type_id != 1 &&
                              financeAcc?.finance_type_id != 2 &&
                              transaction?.editable && (
                                <a class="circle_icon pull-right">
                                  <i class="iconSprites edit-icon">
                                    <div class="tooltip-sm"> Edit </div>
                                  </i>
                                </a>
                              )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div class="my-3">
              {add_accounts_details?.slug != "L02" &&
                add_accounts_details?.slug != "A03" &&
                financeAcc?.finance_type_id != 1 &&
                financeAcc?.finance_type_id != 2 && (
                  <button
                    class="btn green-btn-revert add-plus addSp"
                    id="addCount"
                    type="button"
                    onClick={() =>
                      history.push(
                        `/settings/finance/chart-of-accounts/addTrans/${id}`
                      )
                    }
                  >
                    <i class="i-icon"> </i> Add Transition History
                  </button>
                )}
            </div>
          </div>
          {getPaginationContainer()}
        </div>
        <div acc="1" class="trans"></div>
      </div>
    );
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="top-header-sec">
              <div className="col-12 mt-3">
                <h4 className="event-alert br-btm-0">Sub-Account Details</h4>

                <div className="shadowclass mt-0">
                  <form
                    class="FeatureAddDescriptionForm validate_form"
                    id="FinanceAccountSubAccountsForm"
                    method="post"
                    accept-charset="utf-8"
                    novalidate="novalidate"
                  >
                    {getFormAccAccount()}
                  </form>
                </div>

                <div className="clearfix"> &nbsp; </div>

                <div
                  className="accordion inv-accordion"
                  id="accordionPanelsStayOpenExample"
                >
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine"
                      >
                        <div class="col d-flex align-items-center justify-content-between">
                          <h4 class="event-alert p-0 mb-0">
                            Transaction History
                          </h4>
                          <h5 class="bal-h5">
                            {" "}
                            Balance:{" "}
                            {decimalValue(
                              financeAcc?.current_balance,
                              2,
                              add_accounts_details?.currency
                            )}
                          </h5>
                        </div>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="panelsStayOpen-collapseNine"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingNine"
                  >
                    {getTransactionsContainer()}
                  </div>
                </div>
              </div>
            </div>

            <div className="clearfix"> &nbsp; </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default EditSubAccount;
